module.exports = __webpack_public_path__ + "static/media/blog-img3.df795fd7.jpg";